import React, { Component } from "react";
import axios from "axios";
import Datetime from "react-datetime";
import { v4 as uuidv4 } from 'uuid';
import TextareaAutosize from 'react-textarea-autosize';
import { Row, Column } from "simple-flexbox";
import { Panel, Button } from "react-bootstrap";
import SweetAlert from "sweetalert2-react";
import ReactTooltip from 'react-tooltip';

import ComponentHeader from "../../componentHeader";
import Form from "../../../core/Form";
import Select from "../Select";
import Spinner from "../../Spinner";

import "../../../assets/css/generateOrder.css";
import GenerateOrderIcon from "../../../assets/images/notes.png";

import { IP_ADDRESS_REGEX } from "../../../constants";
import { FETCH_PERMISSIONS } from "../../../actions/types";
import { crudActions } from "../../../services/crudActions";
const store = require("../../../reducers/index");

class GenerateOrder extends Component {
  state = {
    lastUpdate: Datetime.moment().utc().format("HH:mm - DD. MMM YYYY"),
    
    loadingLookups: true,
    loadingDataInput: false,
    isSecondPanelVisible: false,
    isProcessingRequest: false,

    controls: {},
    controlsFormData: {
      merchant: "",
      psp: "",
      midType: "",
      endpoint: "",
      cascading: "false"
    },
    controlsFormRules: [
      {
        name: "merchant",
        type: "isString",
        rules: {
          required: true,
        },
      },
      {
        name: "psp",
        type: "isString",
        rules: {
          required: true,
        },
      },
      {
        name: "midType",
        type: "isString",
        rules: {
          required: true,
        },
      },
      {
        name: "endpoint",
        type: "isString",
        rules: {
          required: true,
        },
      },
      {
        name: "cascading",
        type: "isString",
        rules: {
          required: true,
        },
      }
    ],

    inputsForm: new Form([], []),
    inputs: [],
    additionalInputs: [],
    additionalInputsForm: new Form([], []),

    merchants: [],
    providers: [],
    midTypes: [],
    endpoints: [],
    mids: [],
    currencies: [],
    depositMethods: [],
    payoutMethods: [],
    bankCode: [],
    bankName: [],
    ipAddress: "",

    access: [],

    showSuccess: false,
    successMessage: "",
    showError: false,
    errorMessage: "",
    messageType: "",
    paymentUrl: ""
  };

  subscribeFunction = null;

  componentDidMount() {
    const { controlsFormRules, controlsFormData } = this.state;
    this.setState({
      controls: new Form(controlsFormData, controlsFormRules),
      loading : false
    });

    const storeState = store.default.getState().authReducer;
    if (storeState.access) {
      this.setState({
        access: storeState.access
      });
    }

    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().authReducer;

      if (state.userUpdate === FETCH_PERMISSIONS) {
        this.setState({
          access: state.access,
        });
      }
    });

    Promise.all([
      crudActions.get("v1/adminpanel/lookups"),
      crudActions.get("v1/data/input/lookups")
    ]).then((data) => {
      const adminLookups = data[0];
      const dataLookups = data[1];

      this.setState({
        countries: adminLookups.country || [],
        depositMethods: adminLookups.buyMethods || [],
        payoutMethods: adminLookups.payoutMethods || [],
        merchants: dataLookups.lookups.merchants || [],
        providers: dataLookups.lookups.psp || [],
        currencies: dataLookups.lookups.baseCurrencies || [],
        mids: dataLookups.mids.map((mid) => {
          return {
            value: mid.id,
            label: `${mid.name} (${mid.id})`,
            clients: mid.clients,
            pspId: mid.pspId,
            currency: mid.currency,
            countries: mid.countries
          };
        }),
        payoutMids: dataLookups.payoutMids.map((mid) => {
          return {
            value: mid.id,
            label: mid.name,
            clients: mid.clients,
            pspId: mid.pspId,
            currency: mid.currency,
            countries: mid.countries
          };
        }),
        loadingLookups: false,
      }, () => {
        this.preselectFormValues();
      });
    }).catch((err) => {
      if (err && err.message) {
        this.setState({
          showError: true,
          errorMessage: err.message,
        });
      }
    });

    axios.get("https://geolocation-db.com/json/")
      .then(ipData => {
        if (ipData) {
          const ipAddress = ipData.data.IPv4;
          const reg = new RegExp(IP_ADDRESS_REGEX);
          this.setState({
            ipAddress: reg.test(ipAddress) ? ipAddress : ""
          });
        }
      });
  }

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  }

  getEndpoints = (client) => {
    crudActions.get(`v1/generate-order/endpoints?client=${client}`)
      .then((endpoints) => {
        if (endpoints) {
          // Manually add two new MID types
          if (endpoints.deposit) {
            endpoints = Object.assign(endpoints, {
              "Top up": endpoints.deposit
            });
          }
          if (endpoints.payout) {
            endpoints = Object.assign(endpoints, {
              "Settlement": endpoints.payout
            });
          }
          const endpointsList = {};
          for (const [key] of Object.entries(endpoints)) {
            const sorted = endpoints[key].sort((elemA, elemB) => elemA.localeCompare(elemB));
            Object.assign(endpointsList, {
              [key]: sorted.map((item) => ({
                value: item,
                label: item
              }))
            });
          }

          const midTypes = Object.keys(endpoints).map((elem) => ({
            value: elem,
            label: elem.charAt(0).toUpperCase() + elem.slice(1),
          }));
          midTypes.sort((elemA, elemB) => elemA.label.localeCompare(elemB.label));

          this.setState({
            endpoints: endpointsList,
            midTypes: midTypes
          }, () => {
            if (midTypes.length) {
              this.onValueChange("controls", midTypes[0], "midType");
            }
          });
        }
      }).catch((err) => {
        if (err && err.message) {
          this.setState({
            showError: true,
            errorMessage: err.message
          });
        }
      });
  }

  getInputs = (client, endpoint) => {
    this.setState({
      loadingDataInput: true,
      isSecondPanelVisible: true
    });
    crudActions.get(`v1/generate-order/inputs?client=${client}&url=${endpoint}`)
      .then((inputs) => {
        if (inputs && inputs.length) {
          this.processInputs(inputs, "inputs", "inputsForm");
        }
      }).catch((err) => {
        if (err && err.message) {
          this.setState({
            showError: true,
            errorMessage: err.message,
            loadingDataInput: false
          });
        }
      });
  }

  preselectFormValues = () => {
    const { merchants, providers } = this.state;
    this.onValueChange("controls", merchants[0], "merchant");
    this.onValueChange("controls", providers[0], "psp");
  }

  isNumberField = (field, formId) => {
    const currentInputs = this.state[formId.slice(0, -4)];
    const input = currentInputs.find(e => e.id === field);

    return input.inputType === "number";
  }

  onValueChange = (formId, event, field, shouldValidate) => {
    const { additionalInputsForm, inputsForm, inputs, endpoints } = this.state;
    const controls = { ...this.state.controls };
    const selectedForm = this.state[formId];
    if (!event) {
      selectedForm[field] = event;
    } else if (event.target) {
      if (this.isNumberField(field, formId)) {
        selectedForm[field] = parseFloat(event.target.value);
      } else {
        selectedForm[field] = event.target.value;
      }
    } else if (event.value) {
      selectedForm[field] = event.value;
    } else {
      selectedForm[field] = event.map((elem) => elem.value);
    }

    if (formId !== "controls") {
      selectedForm.isFormValid();
    }

    if (field === "orderSample") {
      if (controls[field] !== event.value) {
        this.setState({
          additionalInputs: [],
          additionalInputsForm: new Form([], [])
        });
      }
      additionalInputsForm.resetValidation();
      inputsForm.resetValidation();
      this.setState({
        additionalInputsForm,
        inputsForm
      });
    }

    if (field === "midId" && event && controls.midType !== "Top up" && controls.midType !== "Settlement") {
      this.getAdditionalFields(event.value);
    }

    if (field === "cascading") {
      const midIdInputIndex = inputs.findIndex(i => i.identifier === "midId");
      const midIdField = inputsForm.fieldRules.find(rule => rule.name === "midId");
      inputs[midIdInputIndex].required = event.value === "false";
      midIdField.rules.required = event.value === "false";
      inputsForm.isFormValid();
    }

    if (field === "midType") {
      const availableEndpoints = endpoints[selectedForm[field]];
      if (availableEndpoints.length === 1) {
        selectedForm.endpoint = availableEndpoints[0].value;
      }
    }

    this.setState({
      [formId]: selectedForm,
      ...(field === "cascading" && { inputsForm }),
      ...(field === "cascading" && { inputs }),
    }, () => {
      if (field === "merchant") {
        this.getEndpoints(selectedForm.merchant);
      }
      if (field === "orderSample") {
        this.setDefaultInputsValues(event.value, false);
      }
    });
  };

  getAdditionalFields = (midId) => {
    const { controls, inputsForm } = this.state;
    crudActions.get(`v1/generate-order/inputs/additional?client=${controls.merchant}&url=${controls.endpoint}&midId=${midId}`)
      .then(response => {
        if (response.amount && (!inputsForm.amount || (parseFloat(response.amount) > parseFloat(inputsForm.amount)))) {
          this.onValueChange("inputsForm", { value: response.amount.toString() }, "amount");
        }
        if (response.fields && response.fields.length) {
          this.processInputs(response.fields, "additionalInputs", "additionalInputsForm");
        } else {
          this.setState({
            additionalInputs: [],
            additionalInputsForm: new Form([], [])
          });
        }
      }).catch((err) => {
        if (err && err.message) {
          this.setState({
            showError: true,
            errorMessage: err.message,
            additionalInputs: [],
            additionalInputsForm: new Form([], [])
          });
        }
      });;
  };

  getOrderSampleOptions = () => {
    return [{
      label: "Manual Entry",
      value: "setManually"
    }, {
      label: "Test Sample",
      value: "setDefault"
    }];
  };

  processInputs = (inputs, arrayId, formId) => {
    const { controls, ipAddress } = this.state;
    const fields = inputs.reduce((acc, cur) => ({
      ...acc, [cur.fieldName]: cur.identifier === "ip" ?
        ipAddress : (cur.fieldName === "transactionId" || cur.fieldName === "orderId") ? uuidv4() : (cur.forceDefault || (controls.orderSample === "setDefault" && formId !== "inputsForm")) ? cur.defaultValue : ""
    }), {});
    const fieldsArray = inputs.map((input) => {
      if (input.dropdownValues && input.inputFieldType === "DROPDOWN") {
        this.setState({
          [input.identifier]: input.dropdownValues
        });
      }
      return {
        id: input.fieldName,
        defaultValue: input.defaultValue,
        inputFieldType: input.inputFieldType,
        ...(input.inputFieldType === "INPUT_FIELD" && { inputType: input.fieldType === "String" ? "text" : "number" }),
        label: input.fieldLabel,
        required: input.identifier === "midId" ? true : input.required, // mark MID ID as required field
        disabled: input.identifier === "ip" && ipAddress !== "",
        forceDefault: input.forceDefault,
        identifier: input.identifier
      };
    });
    const fieldsRules = inputs.map((input) => ({
      name: input.fieldName,
      type: input.identifier === "ip" ? "isPattern" : (input.fieldType === "String" ? "isString" : "isNumber"),
      rules: {
        required: input.identifier === "midId" ? true : input.required, // mark MID ID as required field
        ...(input.identifier === "ip" && { trim: true }),
        ...(input.identifier === "ip" && { pattern: IP_ADDRESS_REGEX }),
      }
    }));
    const inputsForm = new Form(fields, fieldsRules);
    this.setState({
      [formId]: inputsForm,
      [arrayId]: fieldsArray,
      loadingDataInput: false
    }, () => {
      if (formId === "inputsForm") {
        const currencyFieldName = inputs.find(elem => elem.identifier === "currency").fieldName;
        const countryFieldName = inputs.find(elem => elem.identifier === "country").fieldName;
        const currencies = this.getSelectOptions("currency");
        const countries = this.getSelectOptions("country");
        if (currencies.length === 1) {
          this.setState({
            inputsForm: Object.assign(this.state.inputsForm, {
              [currencyFieldName]: currencies[0].value
            })
          });
        }
        if (countries.length === 1) {
          this.setState({
            inputsForm: Object.assign(this.state.inputsForm, {
              [countryFieldName]: countries[0].value
            })
          });
        }
        this.onValueChange("controls", { label: "Test Sample", value: "setDefault" }, "orderSample", true);
      }
    });
  };

  getSelectOptions = (inputId) => {
    const { bankCode, bankName, controls, depositMethods, payoutMids, mids, payoutMethods } = this.state;
    if (!controls.psp || !controls.merchant) {
      return [];
    }

    if (inputId === "midId") {
      if (controls.midType === "deposit" || controls.midType === "Top up") {
        return mids.filter(
          (mid) =>
            mid.clients.some(
              (client) => client.clientId === parseInt(controls.merchant, 10)
            ) && controls["psp"] === mid.pspId.toString()
        );
      } else {
        return payoutMids.filter(
          (mid) =>
            mid.clients.some(
              (client) => client.clientId === parseInt(controls.merchant, 10)
            ) && controls["psp"] === mid.pspId.toString()
        );
      }
    }

    if (inputId === "currency") {
      const availableMids = this.getSelectOptions("midId");
      const availableCurrencies = [...new Set(availableMids.map(a => a.currency))];
      return availableCurrencies.sort().map((elem) => ({
        label: elem,
        value: elem
      }));
    }

    if (inputId === "country") {
      const availableMids = this.getSelectOptions("midId");
      const availableCountries = [...new Set(availableMids.map(a => a.countries.toString()))];
      return this.state.countries.filter(item => availableCountries.some(i => i.includes(item.value)));
    }

    if (inputId === "method") {
      if (controls.midType === "deposit") {
        return depositMethods;
      } else {
        return payoutMethods;
      }
    }

    if (inputId === "bankName") {
      return bankName;
    }

    if (inputId === "bankCode") {
      return bankCode;
    }
  };

  setDefaultInputsValues = (type, shouldValidate) => {
    const { additionalInputs, additionalInputsForm, controls, inputs, inputsForm, ipAddress } = this.state;

    const inputsData = inputsForm.data();
    const additionalInputsData = additionalInputsForm.data();

    const defaultInputs = Object.keys(inputsData).reduce(function(elem, index) {
      const inputIndentifier = inputs.find(input => input.id === index).identifier;
      const inputDefaultValue = inputs.find(input => input.id === index).defaultValue;
      const inputForceDefault = inputs.find(input => input.id === index).forceDefault;

      // do not update ipAddress field or fields with property forceDefault: true
      elem[index] = inputIndentifier !== "ip" ?
        ((index === "transactionId" || index === "orderId") ? uuidv4() :
          (type === "setDefault" ?
            inputsForm[index] ? inputsForm[index] : inputDefaultValue :
            (inputForceDefault ? inputDefaultValue : ""))) :
        ipAddress;
      return elem;
    }, {});

    let defaultAdditionalInputs = [];
    if (additionalInputs.length) {
      defaultAdditionalInputs = Object.keys(additionalInputsData).reduce(function(elem, index) {
        const inputDefaultValue = additionalInputs.find(input => input.id === index).defaultValue;
        const inputForceDefault = additionalInputs.find(input => input.id === index).forceDefault;

        // do not update fields with property forceDefault: true
        elem[index] = type === "setDefault" ? inputDefaultValue : (inputForceDefault ? inputDefaultValue : "");
        return elem;
      }, {});
    }

    if (defaultInputs["midId"] && controls.midType !== "Top up") {
      this.getAdditionalFields(defaultInputs["midId"]);
    }
      
    this.setState({
      inputsForm: Object.assign(inputsForm, defaultInputs),
      additionalInputsForm: Object.assign(additionalInputsForm, defaultAdditionalInputs)
    }, () => {
      if (shouldValidate) {
        this.state.inputsForm.isFormValid();
        this.state.additionalInputsForm.isFormValid();
        this.setState({
          inputsForm: this.state.inputsForm,
          additionalInputsForm: this.state.additionalInputsForm
        });
      }
    });
  };

  onBuildFormClick = () => {
    const { controls } = this.state;
    const isFormValid = controls.isFormValid();
    this.setState({
      controls
    });
    if (isFormValid) {
      this.setState({
        additionalInputs: [],
        additionalInputsForm: new Form([], [])
      }, () => {
        this.getInputs(controls.merchant, controls.endpoint);
      });
    }
  };

  onSendClick = (option) => {
    const { controls, inputsForm, additionalInputsForm } = this.state;
    const isControlsFormValid = controls.isFormValid();
    const isInputsFormValid = inputsForm.isFormValid();
    const isAdditionalInputsFormValid = additionalInputsForm.isFormValid();

    this.setState({
      controls,
      inputsForm,
      additionalInputsForm,
      messageType: option
    });

    if (isControlsFormValid && isInputsFormValid && isAdditionalInputsFormValid) {
      this.setState({
        isProcessingRequest: true
      });
      const { merchant, endpoint, cascading } = controls;

      const inputsData = inputsForm.data();

      const nonEmptyFields = Object.keys(inputsData).reduce(function(elem, index) {
        if (inputsData[index] !== "") elem[index] = inputsData[index];
        return elem;
      }, {});

      const mapPropName = controls.midType === "deposit" || controls.midType === "Top up" ? "map" : "data";
      const data = {
        clientId: merchant,
        url: endpoint,
        data: Object.assign(nonEmptyFields, {
          ...(Object.keys(additionalInputsForm.data()).length > 0 && {
            [mapPropName]: additionalInputsForm.data()
          })
        }),
        isCascade: cascading === 'true',
        ...((controls.midType !== "deposit" && controls.midType !== "payout") && { "excludeFees": true })
      };

      crudActions.post('v1/generate-order', data)
        .then((response) => {
          if (response && response.paymentUrl) {
            if (option === "open") {
              const url = response.paymentUrl.replace(' ','');
              const newTab = window.open(url, '_blank');
              if (newTab) {
                newTab.focus();
              }
            }
          }
          const resetInputsForm = new Form([], []);
          this.setState({
            ...(response.status === "REJECTED" && { showError: true }),
            ...(response.status === "REJECTED" && { errorMessage: response.message }),
            ...(response.status !== "REJECTED" && { showSuccess: true }),
            ...(response.status !== "REJECTED" && { successMessage: option === "open" ? response.message : response.paymentUrl }),
            paymentUrl: response.paymentUrl,
            ...(response.status !== "REJECTED" && { inputs: [] }),
            ...(response.status !== "REJECTED" && { additionalInputs: [] }),
            ...(response.status !== "REJECTED" && { inputsForm: resetInputsForm }),
            ...(response.status !== "REJECTED" && { additionalInputsForm: resetInputsForm }),
            isSecondPanelVisible: response.status === "REJECTED",
            isProcessingRequest: false,
            ...(response.status !== "REJECTED" && {
              controls: Object.assign(controls, {
                midType: "",
                endpoint: ""
              })
            })
          });
        })
        .catch((err) => {
          if (err && err.message) {
            this.setState({
              showError: true,
              errorMessage: err.message.includes("No MID with given ID found") ? "Please check Cascading Settings to generate order." : err.message,
              isProcessingRequest: false
            });
          }
        });
    } else {
      if (!isInputsFormValid) {
        const isIpAddressInvalid = this.state.inputsForm.errors.has("ipAddress");
        if (isIpAddressInvalid) {
          const { inputs } = this.state;
          const ipFieldIndex = inputs.findIndex(i => i.identifier === "ip");
          inputs[ipFieldIndex].disabled = false;
          this.setState({
            inputs,
            showError: true,
            errorMessage: "Invalid IP address. Please try again or check your VPN connection."
          });
        }
      }
    }
  };

  checkPageAccess = (permissionName) => {
    const { access } = this.state;
    const foundPermission = access.find(
      (elem) => elem.permission === permissionName
    );
    if (!foundPermission) {
      return false;
    }

    return foundPermission.state;
  };

  onCopyLink = () => {
    const { paymentUrl } = this.state;
    navigator.clipboard.writeText(paymentUrl);
    this.onAlertConfirm();
  };

  onAlertConfirm = () => {
    this.setState({
      showError: false,
      errorMessage: "",
      showSuccess: false,
      successMessage: "",
      isProcessingRequest: false
    });
  };

  render() {
    const {
      additionalInputs,
      additionalInputsForm,
      merchants,
      providers,
      controls,
      endpoints,
      errorMessage,
      inputs,
      inputsForm,
      isProcessingRequest,
      isSecondPanelVisible,
      loadingLookups,
      loadingDataInput,
      messageType,
      midTypes,
      showError,
      showSuccess,
      successMessage
    } = this.state;

    const loadingContainer = (
      <div
        style={ {
          width: "100%",
          height: "400px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        } }
      >
        <Spinner smallContainer={ true } />
      </div>
    );

    return (
      <Row flexGrow={ 1 } className="t365 module apidata generateOrder" vertical="start">
        <Column flexGrow={ 1 }>
          <ComponentHeader
            title={ "Generate Order" }
            lastUpdate={ this.state.lastUpdate }
            img={ GenerateOrderIcon }
          />
          <Row flexGrow={ 1 } horizontal="start" wrap={ true } vertical="start">
            <Column
              flexGrow={ 1 }
              vertical="start"
              style={ {
                paddingLeft: 15,
                paddingRight: 15,
                paddingTop: 15,
                width: "100%",
              } }
            >
              <Panel>
                <Panel.Heading>
                  <Panel.Title>SELECT</Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  {loadingLookups ? (
                    <>{ loadingContainer }</>
                  ) : (
                    <div
                      className="panel-content"
                      style={ { overflow: "unset" } }
                    >
                      <Row
                        wrap={ true }
                        horizontal="start"
                        vertical="end"
                        style={ { width: "100%" } }
                      >
                        {/* MERCHANT */}

                        <Column
                          flexGrow={ 1 }
                          vertical="start"
                          alignSelf="start"
                          className="input-column"
                        >
                          <label> Merchant </label>
                          <Select
                            id="merchant"
                            name="merchant"
                            value={ controls.merchant || "" }
                            className={
                              controls.errors.has("merchant")
                                ? "error-field"
                                : ""
                            }
                            required={ true }
                            clearable={ false }
                            disabled={ false }
                            onChange={ (value) =>
                              this.onValueChange("controls", value, "merchant")
                            }
                            options={ merchants }
                          />
                        </Column>

                        {/* Provider */}

                        <Column
                          flexGrow={ 1 }
                          vertical="start"
                          alignSelf="start"
                          className="input-column"
                        >
                          <label> Provider </label>
                          <Select
                            id="psp"
                            name="psp"
                            value={ controls.psp || "" }
                            className={
                              controls.errors.has("psp")
                                ? "error-field"
                                : ""
                            }
                            required={ true }
                            clearable={ false }
                            disabled={ false }
                            onChange={ (value) =>
                              this.onValueChange("controls", value, "psp")
                            }
                            options={ providers }
                          />
                        </Column>

                        {/* MID Type */}

                        <Column
                          flexGrow={ 1 }
                          vertical="start"
                          alignSelf="start"
                          className="input-column"
                        >
                          <label> Mid Type </label>
                          <Select
                            id="midType"
                            name="midType"
                            value={ controls.midType || "" }
                            className={
                              controls.errors.has("midType")
                                ? "error-field"
                                : ""
                            }
                            required={ true }
                            clearable={ false }
                            disabled={ false }
                            onChange={ (value) =>
                              this.onValueChange("controls", value, "midType")
                            }
                            options={ midTypes }
                          />
                        </Column>

                        {/* Endpoints */}

                        <Column
                          flexGrow={ 1 }
                          vertical="start"
                          alignSelf="start"
                          className="input-column"
                        >
                          <label> Endpoints </label>
                          <Select
                            id="endpoint"
                            name="endpoint"
                            value={ controls.endpoint || "" }
                            className={
                              controls.errors.has("endpoint")
                                ? "error-field"
                                : ""
                            }
                            required={ true }
                            clearable={ false }
                            disabled={ false }
                            onChange={ (value) =>
                              this.onValueChange("controls", value, "endpoint")
                            }
                            options={ endpoints[controls.midType] }
                          />
                        </Column>
                      </Row>

                      <Row
                        wrap={ true }
                        horizontal="start"
                        vertical="end"
                        style={ { width: "100%" } }
                      >
                        <Column
                          flexGrow={ 1 }
                          vertical="start"
                          alignSelf="start"
                          className="input-column"
                        >
                          <span/>
                        </Column>
                        <Column
                          flexGrow={ 1 }
                          vertical="start"
                          alignSelf="start"
                          className="input-column"
                        >
                          <span/>
                        </Column>
                        <Column
                          flexGrow={ 1 }
                          vertical="start"
                          alignSelf="start"
                          className="input-column"
                        >
                          <span/>
                        </Column>
                        <Column
                          flexGrow={ 1 }
                          vertical="start"
                          alignSelf="start"
                          className="input-column"
                        >
                          <label/>
                          <Button
                            type="button"
                            className="btn defaultBtn"
                            disabled={ false }
                            onClick={ (e) => this.onBuildFormClick() }
                          >
                            Build form
                          </Button>
                        </Column>
                      </Row>

                      {isSecondPanelVisible && (
                        <>
                          {loadingDataInput && (
                            <>{ loadingContainer }</>
                          )}

                          {inputs.length > 0 && !loadingDataInput && (
                            <Row
                              wrap={ true }
                              horizontal="start"
                              vertical="end"
                              style={ { width: "calc(100% - 20px)", margin: "10px" } }
                            >
                              <Panel>
                                <Panel.Heading>
                                  <Panel.Title>ORDER FIELDS</Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                  <Row
                                    wrap={ true }
                                    horizontal="start"
                                    vertical="end"
                                    style={ { width: "100%" } }
                                  >
                                    <Column
                                      flexGrow={ 1 }
                                      vertical="start"
                                      alignSelf="start"
                                      className="input-column"
                                    >
                                      <label> Order Sample </label>
                                      <Select
                                        id="orderSample"
                                        name="orderSample"
                                        value={ controls.orderSample || "" }
                                        className={
                                          controls.errors.has("orderSample")
                                            ? "error-field"
                                            : ""
                                        }
                                        required={ true }
                                        clearable={ false }
                                        onChange={ (value) =>
                                          this.onValueChange("controls", value, "orderSample")
                                        }
                                        options={ this.getOrderSampleOptions() }
                                      />
                                    </Column>
                                    {inputs.map(input =>
                                      <Column
                                        key={ input.id }
                                        flexGrow={ 1 }
                                        vertical="start"
                                        alignSelf="start"
                                        className="input-column"
                                      >
                                        <label> {input.label}{input.required && '*'} </label>
                                        {input.inputFieldType === "DROPDOWN" ? (
                                          <Select
                                            className={ inputsForm.errors.has(input.id) ? 'error-field' : "" }
                                            value={ inputsForm[input.id] }
                                            required={ input.required }
                                            clearable={ true }
                                            withId={ input.identifier === "midId" }
                                            options={ this.getSelectOptions(input.identifier) }
                                            onChange={ (e) => this.onValueChange("inputsForm", e, input.id) }
                                          />
                                        ) : input.inputFieldType === "TEXTAREA" ? (
                                          <TextareaAutosize
                                            cacheMeasurements
                                            value={ inputsForm[input.id] }
                                            disabled={ input.disabled }
                                            className={ "form-control " + (inputsForm.errors.has(input.id) ? 'error-field' : "") }
                                            onChange={ (e) => this.onValueChange("inputsForm", e, input.id) }
                                          />
                                        ) : (
                                          <>
                                            <ReactTooltip effect='solid' type={ 'light' } place={ 'top' } border={ true } getContent={ (dataTip) => <h5>{dataTip}</h5> } />
                                            <div data-tip={ inputsForm[input.id] ? inputsForm[input.id] : null }>
                                              <input
                                                type={ input.inputType }
                                                className={ "form-control " + (inputsForm.errors.has(input.id) ? 'error-field' : "") }
                                                value={ inputsForm[input.id] }
                                                disabled={ input.disabled }
                                                onChange={ (e) => this.onValueChange("inputsForm", e, input.id) }
                                              />
                                            </div>
                                          </>
                                        )}
                                      </Column>
                                    )}
                                    {additionalInputs.map(input =>
                                      <Column
                                        key={ input.id }
                                        flexGrow={ 1 }
                                        vertical="start"
                                        alignSelf="start"
                                        className="input-column"
                                      >
                                        <label> {input.label}{input.required && '*'} </label>
                                        {input.inputFieldType === "DROPDOWN" ? (
                                          <Select
                                            className={ additionalInputsForm.errors.has(input.id) ? 'error-field' : "" }
                                            value={ additionalInputsForm[input.id] }
                                            required={ input.required }
                                            clearable={ true }
                                            withId={ false }
                                            options={ this.getSelectOptions(input.identifier) }
                                            onChange={ (e) => this.onValueChange("additionalInputsForm", e, input.id) }
                                          />
                                        ) : input.inputFieldType === "INPUT_FIELD" ? (
                                          <>
                                            <ReactTooltip effect='solid' type={ 'light' } place={ 'top' } border={ true } getContent={ (dataTip) => <h5>{dataTip}</h5> } />
                                            <div data-tip={ additionalInputsForm[input.id] ? additionalInputsForm[input.id] : null }>
                                              <input
                                                type={ input.inputType }
                                                className={ "form-control " + (additionalInputsForm.errors.has(input.id) ? 'error-field' : "") }
                                                value={ additionalInputsForm[input.id] }
                                                disabled={ input.disabled }
                                                onChange={ (e) => this.onValueChange("additionalInputsForm", e, input.id) }
                                              />
                                            </div>
                                          </>
                                        ) : <></>}
                                      </Column>
                                    )}
                                    {controls.midType === "deposit" && (
                                      <Column
                                        flexGrow={ 1 }
                                        vertical="start"
                                        alignSelf="start"
                                        className="input-column"
                                      >
                                        <label> Cascading </label>
                                        <Select
                                          id="cascading"
                                          name="cascading"
                                          value={ controls.cascading || "false" }
                                          className={
                                            controls.errors.has("cascading")
                                              ? "error-field"
                                              : ""
                                          }
                                          required={ true }
                                          clearable={ false }
                                          onChange={ (value) =>
                                            this.onValueChange("controls", value, "cascading")
                                          }
                                          options={ [
                                            {label: "Yes", value: "true"},
                                            {label: "No", value: "false"}
                                          ] }
                                        />
                                      </Column>
                                    )}
                                      
                                  </Row>
                                </Panel.Body>
                              </Panel>
                            </Row>
                          )}
                          
                          {!loadingDataInput && (
                            <Row
                              wrap={ true }
                              horizontal="end"
                              vertical="end"
                              style={ { width: "100%" } }
                            >
                              {/* GET LINK Button */}
                              {inputs.length > 0 && (controls.midType === "deposit" || controls.midType === "topUp") && (
                                <Column
                                  flexGrow={ 0.1 }
                                  className="input-column fullwidth-button"
                                >
                                  <Button
                                    type="button"
                                    className="btn btn-secondary"
                                    disabled={ inputs.length === 0 || isProcessingRequest }
                                    onClick={ (e) => this.onSendClick("copy") }
                                  >
                                    Get test link
                                  </Button>
                                </Column>
                              )}
                              {/* SEND Button */}
                              <Column
                                flexGrow={ 0.1 }
                                className="input-column fullwidth-button"
                              >
                                <Button
                                  type="button"
                                  className="btn defaultBtn"
                                  disabled={ inputs.length === 0 || isProcessingRequest }
                                  onClick={ (e) => this.onSendClick("open") }
                                >
                                  Send
                                </Button>
                              </Column>
                            </Row>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </Panel.Body>
              </Panel>
            </Column>
          </Row>
        </Column>
        <SweetAlert
          show={ showSuccess }
          title="Success"
          type="success"
          confirmButtonColor="#25282a"
          text={ successMessage }
          confirmButtonText={ messageType === "open" ? "Ok" : "Copy link" }
          onConfirm={ messageType === "open" ? this.onAlertConfirm : this.onCopyLink }
        />
        <SweetAlert
          show={ showError }
          title="Error"
          type="error"
          confirmButtonColor="#25282a"
          text={ errorMessage }
          onConfirm={ this.onAlertConfirm }
        />
      </Row>
    );
  }
}

export default GenerateOrder;
